<template>
	<div>
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
		</v-card-title>
		<v-card-text class="pa-0">
			<keep-alive key="itemlistform">
				<v-form @submit.prevent="search" class="form-inline">
					<v-row>
						<v-col cols="12" class="mt-0 pt-0 d-inline-flex flex-wrap align-center">
							<v-text-field outlined dense hide-details v-model="query.name" style="max-width: 12rem"
								class="mr-2 d-inline-block" label="名称"></v-text-field>

							<v-combobox class="mr-2" style="max-width: 20rem" v-model="query.tags" :items="[]" clearable
								hide-details outlined dense label="标签（可多选）" multiple>
								<template v-slot:selection="{
									attrs,
									item,
									select,
									selected
								}">
									<v-chip small v-bind="attrs" :input-value="selected" close @click="select"
										@click:close="remove(item)">
										<strong>{{ item }}</strong>&nbsp;
									</v-chip>
								</template>
							</v-combobox>
							<v-text-field outlined dense hide-details v-model="query.menuTags" style="max-width: 12rem"
								class="mr-2" label="菜单标签"></v-text-field>
							<v-select outlined dense label="状态" :items="statuses" style="max-width: 8rem" class="mr-2"
								clearable hide-details v-model="query.status"></v-select>
							<category-selector root="PRODUCT" :value="query.category_id" @selected="onCategorySelected"
								class="d-inline mr-2"><template v-if="query.category_id && selectedCategory">{{
									selectedCategory.name }}</template></category-selector>
							<v-btn color="primary" class="mr-2" type="submit">搜索</v-btn>
							<v-btn v-show="queryEntries.length > 0" icon class="mr-2" @click="reset">
								<v-icon>$close</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
			</keep-alive>

			<v-data-table :headers="headers" :items="objects" :options.sync="options"
				:server-items-length="parseInt(total)" :loading="loading" :show-select="showSelect"
				:single-select="singleSelect" v-model="selected" :footer-props="{
					showFirstLastPage: true,
					showCurrentPage: true,
					itemsPerPageOptions: [10, 20, 30]
				}" class="pa-0">
				<template v-slot:top>
					<template>
						<slot name="batchActions" v-bind:selected="selected"></slot>
					</template>
					{{ total }}条数据
				</template>
				<template v-slot:item.name="{ item }">
					<div class="d-flex align-center">
						<span v-if="item.country" :class="'flag-icon flag-icon-' + item.country" />
						<v-img class="d-inline-block" v-if="item.pics && item.pics.length > 0" :src="item.pics[0]"
							size="50" max-width="30" max-height="30" contain></v-img>
						{{ item.name }}
					</div>
					<v-chip v-if="query.menuTags && item.menuTags">{{
						item.menuTags
					}}</v-chip>
				</template>
				<template v-slot:item.category="{ item }">
					<v-chip color="success" dark v-if="item.category_id"
						@click="addQuery('category_id', item.category_id)">
						<template v-if="item.category">
							{{ item.category.name }}
						</template>
						<template v-else>
							无效分类(id={{ item.category_id }})
						</template>
					</v-chip>
				</template>
				<template v-slot:item.modifiedTime="{ item }">
					{{ item.modifiedTime | dateYMDHms }}
				</template>
				<template v-slot:item.status="{ item }">
					<v-chip :color="item.status === 'publish' ? 'success' : 'disabled'
						" dark v-if="item.status">{{ item.statusL }}</v-chip>
				</template>
				<template v-slot:item.action="{ item }">
					<slot name="actions" v-bind:item="item"></slot>
				</template>
				<template v-slot:footer>
					<template>
						<slot name="batchActions" v-bind:selected="selected"></slot>
					</template>
				</template>
			</v-data-table>
		</v-card-text>
	</div>
</template>

<script>
import ItemForm from './Form.vue'
import CategorySelector from '../category/Selector.vue'
import SaleSelector from '../sale/Selector.vue'

import {
	entries,
	keys,
	clone,
	values,
	valuesIn,
	toPairsIn,
	filter,
	intersection
} from 'lodash-es'

export default {
	components: { ItemForm, CategorySelector, SaleSelector },
	props: {
		initQuery: { type: Object, default: null },
		title: { type: String, default: null },
		shopId: { type: [Number, String], default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ text: '#', value: 'id' },
				{ text: '名称', align: 'left', sortable: true, value: 'name' },
				{ text: '分类', value: 'category', sortable: false },
				{ text: '排序值', value: 'sequence', sortable: true },
				{ text: '最近更新', value: 'modifiedTime', sortable: true },
				{ text: '状态', value: 'status', sortable: true },
				{ text: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		return {
			query: {}, //查询条件（还未点击查询按钮）
			currentQuery: {}, //当前结果的查询条件
			errors: {},
			objects: [],
			total: 0,
			loading: false,
			options: {
				sortBy: ['modifiedTime'],
				sortDesc: [true],
				page: 1,
				itemsPerPage: 10
			},
			refs: {},
			selected: [],
			statuses: [],
			selectedCategory: {}
		}
	},
	created() {
		this.$api.common.getMeta('Item', 'statusLabels', (r) => {
			this.statuses = r
		})
	},
	mounted() {
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
	},
	computed: {
		queryEntries() {
			return keys(this.query)
		},
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {
		options: {
			handler() {
				this.load()
			},
			deep: true
		},
		initQuery: {
			handler(nv) {
				this.reset()
				this.query = clone(nv)
				this.search()
			},
			deep: true
		}
	},
	methods: {
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues)
					.length !== this.queryValues.length
			) {
				//条件变化
				if (this.options.page === 1) {
					//当前如果是第一页，手动触发
					this.load()
				} else {
					this.options.page = 1 //当前不是第一页，修改后通过watcher触发
				}
			} else {
				//条件没变，忽略
				//如果先选择了条件，然后清空全部条件后点击搜索
				this.load()
			}
		},
		reset() {
			this.query = {}
			this.query = clone({})
		},
		load() {
			const { sortBy, sortDesc, page, itemsPerPage } = this.options
			this.loading = true

			let params = clone(this.query)
			params.pageno = page
			params.pagesize = itemsPerPage

			if (sortBy.length > 0) params.sortBy = sortBy[0]
			if (sortDesc.length > 0)
				params.sortDesc = sortDesc[0] === false ? 'asc' : 'desc'

			if (this.shopId) {
				params.shop_id = this.shopId
			}
			this.$api.item.search(
				params,
				(response) => {
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		},
		onCategorySelected(ids, objs) {
			this.query['category_id'] = ids[0]
			let tmp = clone(this.query)
			this.query = tmp
			// this.$set(this, 'query', this.query)
			this.selectedCategory = objs[0]
		},
		addQuery(n, v) {
			this.query[n] = v
			this.search()
		},
		clearSelected() {
			this.selected = []
		}
	}
}
</script>

<style scoped></style>
